import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-166" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" data-id="element-167" data-mp="3fym70jljx03t">
        <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-168" data-mp="3fxb40lzxjwdr">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-169" data-mp="36zilza2tqamo" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}